import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import { useQuery } from 'data-fetching-client';
import ListBranchDebugFilterBranchSection from 'flow-doctor-lib/components/actions/ListBranchDebugFilterBranchSection';
import { GET_HISTORICAL_LIST_EVAL_BATCH } from 'flow-doctor-lib/queries/FlowDoctorQueries';
import Raven from 'raven-js';
import { useEffect, useState } from 'react';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import { jsx as _jsx } from "react/jsx-runtime";
const ListBranchDebugFilterBranchList = ({
  branchConnectionsForAction,
  logEvent
}) => {
  const [isBranchHistoryUnavailable, setIsBranchHistoryUnavailable] = useState(false);
  const listIds = branchConnectionsForAction.map(branch => branch.listId);
  const {
    loading: isHistoricEvaluationLoading,
    data: debugData,
    error
  } = useQuery(GET_HISTORICAL_LIST_EVAL_BATCH, {
    variables: {
      portalId: logEvent.portalId,
      listIds,
      timestamp: logEvent.timestamp,
      objectTypeId: logEvent.objectTypeId,
      objectId: logEvent.objectId
    }
  });
  useEffect(() => {
    if (debugData) {
      const branchHistoryResultsMap = debugData.historicalListEvalBatch;
      const firstAcceptedBranch = branchConnectionsForAction.find(branch => {
        const currentBranchHistoryResult = branchHistoryResultsMap[branch.listId];
        return currentBranchHistoryResult && currentBranchHistoryResult.acceptedStatus === 'ACCEPTED';
      });
      if (!firstAcceptedBranch && !!logEvent.contextMap.ACCEPTED_LIST_ID || firstAcceptedBranch && logEvent.contextMap.ACCEPTED_LIST_ID !== firstAcceptedBranch.listId) {
        Raven.captureMessage('Met branch does not match with the first accepted branch in the historical list evaluation.', {
          extra: {
            metBranchListId: logEvent.contextMap.ACCEPTED_LIST_ID,
            firstAcceptedBranchListId: firstAcceptedBranch && firstAcceptedBranch.listId
          }
        });
        setIsBranchHistoryUnavailable(true);
      }
    }
  }, [debugData, branchConnectionsForAction, logEvent.contextMap.ACCEPTED_LIST_ID]);
  if (error) {
    Raven.captureMessage('Error fetching historical list evaluation results', {
      extra: {
        error
      }
    });
  }
  if (isHistoricEvaluationLoading || !debugData) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      minHeight: 150,
      layout: "centered"
    });
  }
  return /*#__PURE__*/_jsx(Tile, {
    margin: "0",
    distance: "flush",
    children: isBranchHistoryUnavailable && !getIsInternal() ? /*#__PURE__*/_jsx(TileSection, {
      padding: "250",
      children: /*#__PURE__*/_jsx(UIAlert, {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.listBranchDebugPanel.unavailableBranchHistoryAlert.title"
        }),
        type: "info",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.listBranchDebugPanel.unavailableBranchHistoryAlert.description"
        })
      })
    }) : /*#__PURE__*/_jsx(TileSection, {
      padding: "0",
      children: branchConnectionsForAction.map((branchConnection, index) => /*#__PURE__*/_jsx(ListBranchDebugFilterBranchSection, {
        logEvent: logEvent,
        branchNum: index + 1,
        branchConnection: branchConnection,
        historicalEvalBranch: debugData.historicalListEvalBatch[branchConnection.listId]
      }, index))
    })
  });
};
export default ListBranchDebugFilterBranchList;